<template>
  <div>
    <!-- 全屏显示PDF的容器 -->
    <div v-if="isFullScreen" class="pdf-container" @touchstart="onTouchStart" @touchmove="onTouchMove" ><!-- @touchend="onTouchEnd" -->
     
      <div ref="pdfViewer" class="pdf-viewer" @click="onPDFClick"></div>
      <div class="pdf-controls">
        <button @click="previousPage">上一页</button>
        <button @click="nextPage">下一页</button>
        <span>页数：{{ currentPage }} / {{ totalPages }}</span>
      </div>
      <!-- 放大缩小手势示意图 -->
        <div v-if="gestureHintVisible">
          <div v-if="isZoomIn" class="gest-hint" style="z-index:9999">
              <img :src="inImage" alt="放大手势" class="gesture-img"/>
              <p>双指张开放大</p>
          </div>
          <div v-else class="gest-hint" style="z-index:9999">
              <img :src="outImage" alt="缩小手势" class="gesture-img"/>
              <p>双指合拢缩小</p>
          </div>
          <!-- 放大手势提示 -->
          <!-- <div v-if="showInHint" class="gest-hint" style="z-index:9999">
              <img :src="inImage" alt="放大手势" class="gesture-img"/>
              <p>双指张开放大</p>
          </div> -->

          <!-- 缩小手势提示 -->
          <!-- <div v-if="showOutHint" class="gest-hint" style="z-index:9999">
              <img :src="outImage" alt="缩小手势" class="gesture-img"/>
              <p>双指合拢缩小</p>
          </div> -->
        </div>
    </div>
  </div>
</template>

<script>
// import pdfjsLib from 'pdfjs-dist';
const PDFJS = require("pdfjs-dist");

PDFJS.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker.min");

export default {
  props: {
        // 组件引入的pdf地址
        pdfUrl: {
            type: String,
            default: ""
        }
    },
  data() {
    return {
      isFullScreen: false,  // 是否全屏显示PDF
      currentPage: 1,  // 当前页面
      totalPages: 0,  // 总页数
      pdfDoc: null,  // PDF文档对象
      scale: 1,  // PDF缩放比例
      showInHint: false,   // 控制放大手势提示的显示
      showOutHint: false,  // 控制缩小手势提示的显示
      ratioValue:0.3,//缩放尺寸
      inImage: require('@/assets/img/img_b.jpg'), // 本地图片路径
      outImage: require('@/assets/img/img_s.jpg'), // 本地图片路径
      isZoomIn:true,//默认放大
      gestureHintVisible: false, // 是否显示手势示意图
      gestureHintDisplayed: false,  // 是否已经显示过手势示意图
    };
  },
  mounted(){
    console.log( this.pdfUrl,'-------子页面url')
    this.isFullScreen = true;
      this.loadPDF();
  },
  methods: {
    
    // 加载PDF
    loadPDF() {
      // const url ='https://www.xsdjp.com/book/1.pdf';  // PDF文件的路径
      const url = this.pdfUrl;  // PDF文件的路径
      console.log(url,'----url');
      PDFJS.getDocument(url).promise.then(pdf => {
        this.pdfDoc = pdf;
        this.totalPages = pdf.numPages;
        // this.renderPage(this.currentPage);
        console.log("PDF加载成功，页数：" + this.totalPages);
        setTimeout(() => {
          this.renderPage(this.currentPage);
        }, 100);  // 延迟100ms
      }).catch(error => {
        console.error("PDF加载失败，请检查路径或跨域问题：", error);
      });
    },
    // 渲染页面
    renderPage(pageNum) {
      const container = this.$refs.pdfViewer;
      container.innerHTML = ''; // 清空容器内容
      this.pdfDoc.getPage(pageNum).then(page => {
        if (!page) {
          console.error("获取页面对象失败，page 为 null 或 undefined");
          return;
        }
        const scale = this.scale ||1; // 缩放比例
        if (isNaN(scale) || scale <= 0) {
          console.error("无效的 scale 参数：", scale);
          return;
        }
        // const viewport = page.getViewport({ scale });//旧版本不支持对象
        const viewport = page.getViewport(scale);
        if (!viewport || isNaN(viewport.width) || isNaN(viewport.height)) {
          console.error("视口生成失败，viewport 信息无效");
          return;
        }
       
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        // canvas.height = viewport.height;
        // canvas.width = viewport.width;
        // 获取设备的像素比率
         const devicePixelRatio = window.devicePixelRatio || 1;
        // 调整 Canvas 尺寸以匹配高分辨率
        canvas.width = viewport.width * devicePixelRatio;
       
        canvas.height = viewport.height * devicePixelRatio;
        canvas.style.width = `${viewport.width}px`; // 显示大小
        // canvas.style.height = `${viewport.height}px`;
        canvas.style.maxWidth = `100vw`;
        canvas.style.maxHeight = `100vh`;
        canvas.style.display = `block`;
        canvas.style.margin = `0 auto`;
        // 缩放 Canvas 的绘图上下文
        context.scale(devicePixelRatio, devicePixelRatio);
        page.render({
          canvasContext: context,
          viewport: viewport,
        }).promise.then(() => {
          const pdfViewer = this.$refs.pdfViewer;
          pdfViewer.innerHTML = '';
          pdfViewer.appendChild(canvas);
          // console.log("第", pageNum, "页渲染成功");
        }).catch(error => {
          console.error("页面渲染失败：", error);
        });
      }).catch(error => {
        console.error("获取页面失败：", error);
      });
    },
    onPDFClick(event){
      const rect = this.$refs.pdfViewer.getBoundingClientRect();
      const clickX = event.clientX - rect.left; // 点击点相对于容器的 X 坐标
      const containerWidth = rect.width;
      console.log(rect,'----rect')
      console.log(clickX,'----clickX')
      console.log(containerWidth,'----containerWidth')
      if (clickX < containerWidth / 2) {
        this.previousPage(); // 点击左侧，翻到上一页
      } else {
        this.nextPage(); // 点击右侧，翻到下一页
      }
    },
    // 上一页
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.renderPage(this.currentPage);
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.renderPage(this.currentPage);
      }
    },
    // 处理触摸缩放
    onTouchStart(event) {
      if (event.touches.length === 2) {
        this.startDistance = this.getTouchDistance(event);//赋值为初始两指的距离
        this.gestureHintVisible = true; // 显示手势示意图
      }
    },
    onTouchMove(event) {
      if (event.touches.length === 2) {
        const currentDistance = this.getTouchDistance(event);//// 当前两指距离
        const diff = currentDistance - this.startDistance;
        const scaleChange = currentDistance / this.startDistance;  // 计算缩放比例变化
      //    // 判断是否是放大还是缩小
      //  this.isZoomIn = scaleChange > 1;
      if (!this.gestureHintDisplayed) { // 如果手势示意图还未显示过，才显示
        
        if(this.startDistance < currentDistance){//放大
          this.isZoomIn=true
        setTimeout(() => {
          this.gestureHintVisible=false
        },500);
          // this.showInHint = true; // 显示手势示意图
          // this.showOutHint = false; // 显示手势示意图
          // alert('放大')
        }else{//缩小
          this.isZoomIn=false
        setTimeout(() => {
          this.gestureHintVisible=false
        },500);
          // this.showOutHint = true; // 显示手势示意图
          // this.showInHint = false;
          // alert('缩小')
        }
      }
        // 根据距离变化调整缩放比例
        if (diff > 10) {
          this.scale += 0.1;
          this.renderPage(this.currentPage);
        } else if (diff < -10) {
          this.scale -= 0.1;
          this.renderPage(this.currentPage);
        }

        this.startDistance = currentDistance;
        //  setTimeout(() => {
        //   this.gestureHintVisible=false
        //     // this.showOutHint = false; // 显示手势示意图
        //     // this.showInHint = false;
        //     // this.isZoomIn=false
        //  },500);
      
      }
    },
    // onTouchEnd(event){
    //     setTimeout(() => {
    //       this.gestureHintVisible=false
    //     },500);
    // },
    getTouchDistance(event) {
      const touch1 = event.touches[0];
      const touch2 = event.touches[1];
      const dx = touch2.pageX - touch1.pageX;
      const dy = touch2.pageY - touch1.pageY;
      return Math.sqrt(dx * dx + dy * dy);
    },
  },
};
</script>

<style scoped>

.pdf-viewer {
  width: 100%;  /* 容器宽度 */
  /* height: 100vh;   *//* 视口高度 */
  position: relative;
}
.pdf-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  z-index: 9999;
  overflow: hidden;
}

.pdf-controls {
  /* position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin:10px 0;
}
.pdf-controls button{
  margin-right:10px ;
  background:#409eff;
  color:#fff;
  border:0;
  padding:4px 7px;
}
.pdf-viewer canvas {
  width: 100%;
  height: auto;
  margin-top: 35px;
}

</style>
<style>
.gest-hint {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  padding: 10px 20px;
  border-radius: 5px;
  color: white;
  font-size: 16px;
  text-align: center;
  z-index: 9999;  /* 确保提示图显示在最上层 */
}
.gest-hint img {
  width: 100px;  /* 调整图片大小 */
  height: auto;
  margin-bottom: 10px;
}

.gest-hint p {
  margin: 0;
  font-size: 14px;
  margin-top: 5px;
}
</style>




// WEBPACK FOOTER //
// src/components/pdfjsA.vue